module.exports = __webpack_public_path__ + "static/img/2021.1297099.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2021.png
// module id = XiO8
// module chunks = 1